import type { FaireProductEntity } from "../../entity_types/product";

export const p_22nnrrtvbx: FaireProductEntity = {
  token: "p_22nnrrtvbx",
  type: "product",
  name: "Elegant Floral Print High-Waist Maxi Dress for Women",
  brandToken: "b_999ccmmbkw",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/309edbe6584e205a0ed150e21d635947f6de3431083e80a00f19077d2da6ef54.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bebea256681cac9c6550d2c5780ec06991b1947dcc3f01e4e43c96da4ee2e279.jpeg",
    "https://cdn.faire.com/fastly/f1ed80de7e5b7766714b79ecfe297ef491a4a94be53099c65539988082697cbb.jpeg",
    "https://cdn.faire.com/fastly/b237cd3425621c5af046ed6edd307ca6282928dead4b57bd2f56eadd371a007d.jpeg",
    "https://cdn.faire.com/fastly/a983253bb9a7a8f7ddbbcfee173cc700d6b1d73f6fdf8d6ce44740a0667274ab.jpeg",
    "https://cdn.faire.com/fastly/c37c58aba9f8a8fca5d8c8d989c1be228912fd6a6ee2acbb31cd3f55dd4a36d0.jpeg",
  ],
  priceDollars: 24.25,
  description:
    "This stunning maxi dress features a chic and sophisticated design, perfect for casual outings or workplace wear. Made from premium polyester fabric, it is lightweight and breathable, ensuring comfort throughout the day. The dress boasts a high-waisted silhouette that flatters your figure, and the sleeveless design allows for easy styling with accessories.\n\nKey Features:\n\n * Material: 95% Polyester for comfort and durability \n * Style: Elegant and refined, suitable for various occasions \n * Care: No-iron treatment for easy maintenance \n * Dress Length: Maxi, offers a flowy and graceful look \n * Fit: Slim-fit design, size up for a looser fit \n * Available Colors: Pink, Blue, Apricot, Green \n * Sizes: S, M, L, XL, 2XL, 3XL \nThis elegant dress is designed to enhance your natural beauty while providing comfort and style. Ideal for both casual and business settings, it makes a versatile addition to your wardrobe.\n",
  tags: [],
  msrpDollars: 48.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:29:27.758Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
